import { render, staticRenderFns } from "./customers-container.vue?vue&type=template&id=5ce1f59e&scoped=true&"
import script from "./customers-container.vue?vue&type=script&lang=ts&"
export * from "./customers-container.vue?vue&type=script&lang=ts&"
import style0 from "./customers-container.vue?vue&type=style&index=0&id=5ce1f59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1f59e",
  null
  
)

export default component.exports